import {Component, Input} from '@angular/core';
import {Booking} from '../../../core/entities/booking/booking.entity';
import { CurrencyPipe, DatePipe } from '@angular/common';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {AppImageComponent} from '../../../core/components/image/image';
import {HelperBannerComponent} from '../../../core/components/helper-banner/helper-banner.component';
import {BookingService} from '../../services/booking/booking.service';
import {ToastrService} from 'ngx-toastr';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-booking-list-item',
  imports: [
    CurrencyPipe,
    TranslocoPipe,
    DatePipe,
    RouterLink,
    AppImageComponent,
    HelperBannerComponent
  ],
  templateUrl: './booking-list-item.component.html',
  styleUrl: './booking-list-item.component.scss'
})
export class BookingListItemComponent {
  @Input() booking: Booking|null = null;

  public payingBalance = false;

  public constructor(
    private readonly bookingService: BookingService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
  ) {}

  public getPhotosUrl(): string[]
  {
    if (!this.booking) {
      return [];
    }

    return [
      '/my-account',
      'booking',
      this.booking.id.toString(),
      'photos'
    ]
  }

  public shouldShowPayBalance(): boolean {
    if (!this.booking || this.booking.balanceAmount === undefined || this.booking.balanceAmount === null) {
      return false;
    }

    if (this.booking.balanceAmount <= 0) {
      return false;
    }

    return this.booking.balanceStatus === 'pending' || this.booking.balanceStatus === 'failed';
  }

  public getBalanceAmount(): number|null {
    if (!this.booking || this.booking.balanceAmount === undefined || this.booking.balanceAmount === null) {
      return null;
    }

    return this.booking.balanceAmount / 100;
  }

  public async payRemainingBalance(): Promise<void> {
    if (!this.booking) {
      return;
    }

    this.payingBalance = true;

    try {
      const response = await firstValueFrom(
        this.bookingService.payRemainingBalance(this.booking.id)
      );

      window.location.href = response.checkoutUrl;
    } catch (error: any) {
      this.toastr.error(
        error?.message ?? this.transloco.translate('marketplace.account.bookings.actions.pay-balance.error.generic')
      );
    } finally {
      this.payingBalance = false;
    }
  }
}
